import Provider from '../Provider';
import { isComputedValue } from '../utils';
export default Provider(function (context) {
  return Object.assign(function (tag, overrides) {
    var value = context.resolve.value(tag);
    if (isComputedValue(value)) {
      return value.getValue(overrides || context.props);
    }
    return value;
  }, {
    path: function path(tag) {
      return context.resolve.path(tag);
    }
  });
}, {
  wrap: false
});